import React from 'react';

const SurveyView = () =>{
    return(
        <>
        <h1>View A specific Survey Here!</h1>
        </>
    )
}

export default SurveyView